/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPackageSubscriber } from 'app/shared/model/package-subscriber.model';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';
import { BillOrigin } from 'app/shared/model/enumerations/bill-origin.model';

export interface IPackageSubscriptionDiscount {
  id?: string;
  discount?: number | null;
  actualDiscount?: number | null;
  billNumber?: string | null;
  billDate?: number;
  billType?: keyof typeof BillType;
  billId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  remarks?: string | null;
  exception?: boolean | null;
  billOrigin?: keyof typeof BillOrigin | null;
  usedBy?: IPackageSubscriber | null;
}

export const defaultValue: Readonly<IPackageSubscriptionDiscount> = {
  active: false,
  exception: false,
};
